<p-dialog modal="true" styleClass="atlas-dialog-m" position="top" [closable]="false" [(visible)]="show">
  <ng-template pTemplate="header">
    <h4>
      {{ 'form-builder.edit-form-element' | translate | titlecase }}
    </h4>
  </ng-template>
  <div class="mct-flex mct-col mct-gap-27">
    <div>
      <label>{{ 'form-builder.element-type-label' | translate | ucfirst }}</label>
      <p-select
        name="ElementType"
        [options]="elementTypeOptions"
        [(ngModel)]="proposedElement.ElementType"
        appendTo="body"
        [style]="{ width: '100%' }"
        (onChange)="elementTypeChanged()"
      ></p-select>
    </div>
    <form #editForm="ngForm">
      <div *ngIf="proposedElement.ElementType === elementType.Header">
        <label>{{ 'common.text' | translate | ucfirst }}</label>
        <input name="DisplayValue" class="form-control" [(ngModel)]="proposedElement.DisplayValue" />
      </div>
      <div *ngIf="proposedElement.ElementType === elementType.Header">
        <label>{{ 'form-builder.sub-header' | translate | ucfirst }}</label>
        <input name="DisplayValue2" class="form-control" [(ngModel)]="proposedElement.DisplayValue2" />
      </div>
      <div *ngIf="proposedElement.ElementType === elementType.TextBlock && displayHtmlEditor">
        <label>{{ 'common.text' | translate | ucfirst }}</label>
        <wl-wysiwyg-editor
          name="DisplayValue"
          [showHtmlTemplates]="false"
          [disableImageSelector]="true"
          [(ngModel)]="proposedElement.DisplayValue"
          [compact]="true"
        ></wl-wysiwyg-editor>
      </div>
      <div *ngIf="proposedElement.ElementType === elementType.ProfileIndividual">
        <wl-profile-lego-edit [(profileData)]="proposedElement.MetaData.ProfileData"></wl-profile-lego-edit>
      </div>
      <div *ngIf="proposedElement.ElementType === elementType.ProfileOrganization">
        <wl-profile-lego-edit isOrg="true" [(profileData)]="proposedElement.MetaData.ProfileData"></wl-profile-lego-edit>
      </div>
      <div *ngIf="proposedElement.ElementType === elementType.PurchaseItem">
        <wl-purchase-item-lego-edit [(purchaseItemData)]="proposedElement.MetaData.PurchaseItemData"></wl-purchase-item-lego-edit>
      </div>
      <div *ngIf="proposedElement.ElementType === elementType.CustomField">
        <wl-custom-field-lego-edit [(customFieldData)]="proposedElement.MetaData.CustomFieldData"></wl-custom-field-lego-edit>
      </div>
      <div *ngIf="proposedElement.ElementType === elementType.AffiliationCode">
        <wl-affiliation-code-lego-edit
          [(affiliationCodeData)]="proposedElement.MetaData.AffiliationCodeData"
        ></wl-affiliation-code-lego-edit>
      </div>
      <div *ngIf="proposedElement.ElementType === elementType.Listings">
        <wl-listing-lego-edit [(listingData)]="proposedElement.MetaData.ListingData"></wl-listing-lego-edit>
      </div>
      <div *ngIf="proposedElement.ElementType === elementType.MembershipLevel">
        <wl-membership-level-lego-edit [membershipLevelData]="proposedElement.MetaData.MembershipLevelData"></wl-membership-level-lego-edit>
      </div>
      <div *ngIf="proposedElement.ElementType === elementType.SocialMedia">
        <wl-social-media-lego-edit [socialMediaData]="proposedElement.MetaData.SocialMediaData"></wl-social-media-lego-edit>
      </div>
      <div *ngIf="proposedElement.ElementType === elementType.FileUpload">
        <wl-file-upload-lego-edit [fileUploadData]="proposedElement.MetaData.FileUploadData"></wl-file-upload-lego-edit>
      </div>
      <div *ngIf="proposedElement.ElementType === elementType.OpenField">
        <wl-open-field-lego-edit [openFieldData]="proposedElement.MetaData.OpenFieldData"></wl-open-field-lego-edit>
      </div>
    </form>
  </div>
  <ng-template pTemplate="footer">
    <wl-save-cancel-actions [isSaveDisabled]="editForm.invalid" (onSave)="save()" (onCancel)="cancel()"> </wl-save-cancel-actions>
  </ng-template>
</p-dialog>
